/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceAlertsUsageDto
 */
export interface PriceAlertsUsageDto {
    /**
     * Number of users with at least one price alert
     * @type {number}
     * @memberof PriceAlertsUsageDto
     */
    usersCount: number;
    /**
     * Percentage of total users
     * @type {number}
     * @memberof PriceAlertsUsageDto
     */
    percentage: number;
    /**
     * Total number of price alerts across all users
     * @type {number}
     * @memberof PriceAlertsUsageDto
     */
    totalAlerts: number;
}

export function PriceAlertsUsageDtoFromJSON(json: any): PriceAlertsUsageDto {
    return PriceAlertsUsageDtoFromJSONTyped(json, false);
}

export function PriceAlertsUsageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceAlertsUsageDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'usersCount': json['usersCount'],
        'percentage': json['percentage'],
        'totalAlerts': json['totalAlerts'],
    };
}

export function PriceAlertsUsageDtoToJSON(value?: PriceAlertsUsageDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'usersCount': value.usersCount,
        'percentage': value.percentage,
        'totalAlerts': value.totalAlerts,
    };
}

